import '@cta/frontend';

import '@campact/camper/core/CmprButton.css';
import '@campact/camper/core/CmprSharingButton';
import '@campact/camper/core/CmprCopyButton';
import '@campact/camper/core/CmprTicker';

import './index.scss';

import { installErrorHandler } from '@appsignal/stimulus';
import appsignal from '@cta/shared/appsignal';
import { Application } from '@hotwired/stimulus';
import Rails from '@rails/ujs';
import RecommendController from './controllers/recommend_controller';

Rails.start();

const application = Application.start();
installErrorHandler(appsignal, application);
application.register('recommend', RecommendController);
